export default function EditProfileIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' fill='none'>
      <path
        d='m9.873 6.013.614.614-6.04 6.04h-.614v-.614l6.04-6.04ZM12.273 2a.667.667 0 0 0-.466.193l-1.22 1.22 2.5 2.5 1.22-1.22c.26-.26.26-.68 0-.94l-1.56-1.56A.655.655 0 0 0 12.273 2Zm-2.4 2.127L2.5 11.5V14H5l7.373-7.373-2.5-2.5Z'
        fill='#fff'
      />
    </svg>
  );
}
